import { API_URL } from '../../../config'
import store from '../../store'

export default {
  namespaced: true,
  actions: {
    async getMisReportes() {
      const response = await fetch(`${API_URL}/reportes/permisos/mis-reportes`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async getFuncionesReportes() {
      const response = await fetch(`${API_URL}/reportes/permisos/funciones`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async getReportesPerfil(_, perfilId) {
      const response = await fetch(`${API_URL}/reportes/permisos/perfil/${perfilId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async guardarReportesPerfil(_, { perfilId, funciones }) {
      const response = await fetch(`${API_URL}/reportes/permisos/perfil/${perfilId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify({ funciones })
      })
      return response.json()
    },

    async getReportesUsuario(_, usuarioId) {
      const response = await fetch(`${API_URL}/reportes/permisos/usuario/${usuarioId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async guardarReportesUsuario(_, { usuarioId, funciones }) {
      const response = await fetch(`${API_URL}/reportes/permisos/usuario/${usuarioId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify({ funciones })
      })
      return response.json()
    }
  }
}
